import React, { useState } from 'react'
import { SellOrderContext } from '../../../../providers/SellOrdersProvider'
import { Body, Header, OrdersContainer, CountBadge } from '../../styles'
import ConfirmedOrderItem from './ConfirmedOrderItem'

function ConfirmedOrders() {
  const { confirmadas: orders, fetch, vendorsArray: vendors, vendorsIdArray: vendorIds } = React.useContext(SellOrderContext);
  const [selectedVendor, setSelectedVendor] = useState('all');

  const filterOrders = React.useMemo(() => {
    if (selectedVendor === 'all') {
      return orders;
    } else if (selectedVendor === 'oficina') {
      return orders.filter(order => !vendorIds.includes(order.user.id))
    } else {
      return orders.filter(order => order.user.id === selectedVendor)
    }
  }, [selectedVendor, orders, vendorIds])

  const handleSelectVendor = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedVendor(e.target.value);
  }

  const count = filterOrders.length;

  return (
    <OrdersContainer>
      <Header>
        <div style={{ fontWeight: 600, display: 'flex', alignItems: 'center' }}>
          Ventas confirmadas
          <CountBadge $zero={count === 0}>{count}</CountBadge>
        </div>
        <select name="vendors" id="vendors" value={selectedVendor} onChange={handleSelectVendor}>
          <option value="all">Todos</option>
          <option value="oficina">Oficina</option>
          {vendors.map(v => (
            <option key={v.value} value={v.value}>{v.label}</option>
          ))}
        </select>
      </Header>
      <Body>
        {filterOrders.length === 0 && <h3>No hay ventas confirmadas</h3>}
        {filterOrders.map((o, i) => (
          <ConfirmedOrderItem
            key={i}
            order={o}
            refresh={fetch}
          />
        ))}
      </Body>
    </OrdersContainer>
  )
}

export default ConfirmedOrders